import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProfileAcademy from "./ProfileAcademy";

const BACKEND_URL = "https://linxlegacyacademy.dk";

export default function ProfileRouter() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchUser() {
      try {
        const res = await fetch(`${BACKEND_URL}/auth/user`, { credentials: "include" });
        const data = await res.json();

        if (data.status === "logged_in") {
          setUser(data.user);
        } else {
          navigate("/login"); // redirect til login hvis ikke logget ind
        }
      } catch (err) {
        console.error(err);
        navigate("/login");
      } finally {
        setLoading(false);
      }
    }
    fetchUser();
  }, [navigate]);

  if (loading) return <p style={{ textAlign: "center", marginTop: "4rem" }}>Indlæser...</p>;

  if (!user) return null; // allerede redirectet

  return <ProfileAcademy user={user} />;
}